__turbopack_context__.v({
  "eyebrow": "DmsServicesCardSection-module__c-DE1G__eyebrow",
  "section": "DmsServicesCardSection-module__c-DE1G__section",
  "title": "DmsServicesCardSection-module__c-DE1G__title",
});
